export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7600.53d5c8ab.jpg";